export default __webpack_public_path__ + "b755700add92ba360517f3c8e4252e35.png";